module.exports = __webpack_public_path__ + "static/miwc-black-397f964b50baef9f883954a4301e3c03.png";